import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { QuizResultsCircular } from "../../quiz-results-circular/quiz-results-circular";
import {
  containerStyle,
  titleBoxStyle,
  titleStyle,
  progressContainerStyle,
  progressRowStyle,
  progressLabelStyle,
  linearProgressStyle,
} from "./styles";

interface HeaderQuizProps {
  progress?: number;
  totalAnswers?: number;
}

export const HeaderQuiz: React.FC<HeaderQuizProps> = ({
  progress = 20,
  totalAnswers = 12,
}) => {
  return (
    <Box sx={containerStyle}>
      <Box sx={titleBoxStyle}>
        <Typography sx={titleStyle}>Test your knowledge 🧠</Typography>
      </Box>

      <Box sx={progressContainerStyle}>
        <Box sx={progressRowStyle}>
          <Typography variant="body2" sx={progressLabelStyle}>
            Progress
          </Typography>
          <Typography variant="body2" sx={progressLabelStyle}>
            {progress}%
          </Typography>
        </Box>
        <Box sx={{ width: "100%" }}>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={linearProgressStyle}
          />
        </Box>
      </Box>

      <QuizResultsCircular totalAnswers={totalAnswers} hidePoints />
    </Box>
  );
};

export default HeaderQuiz;
